<template>
    <div class="generate-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-s-order"></i>
                    <span>作文生成训练</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选学生</span>
                </div>
            </div>
            <el-form :inline="true" :model="filterForm" class="filter-form">
                <el-form-item label="年级">
                    <el-select v-model="filterForm.gradeId" placeholder="请选择年级" clearable @change="handleGradeChange" style="width:150px">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="filterForm.classId" placeholder="请选择班级" clearable :disabled="!filterForm.gradeId" style="width:150px">
                        <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input v-model="filterForm.studentNo" placeholder="请输入学号" clearable style="width:150px"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="filterForm.userName" placeholder="请输入姓名" clearable style="width:140px"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="filterForm.phone" placeholder="请输入手机号" clearable style="width:150px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="loadStudents">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 内容区域 -->
        <el-card shadow="always" class="table-card">
            <el-row :gutter="20">
                <!-- 左侧：学生列表 -->
                <el-col :span="6">
                    <div class="student-list-container">
                        <div class="list-header">
                            <h3>学生列表</h3>
                            <span class="count-badge">{{ studentList.length }}</span>
                        </div>
                        <el-scrollbar style="height: calc(100vh - 280px);">
                            <div
                                v-for="student in studentList"
                                :key="student.id"
                                class="student-card"
                                :class="{ 'active': selectedStudent && selectedStudent.id === student.id }"
                                @click="handleStudentSelect(student)">
                                <div class="student-avatar" :style="{ background: getAvatarColor(student.id) }">
                                    {{ getAvatarText(student.nickname || student.username) }}
                                </div>
                                <div class="student-info">
                                    <div class="student-name">{{ student.nickname || student.userName }}</div>
                                    <div class="student-meta">
                                        <span class="meta-item">
                                            <i class="el-icon-collection-tag"></i>
                                            {{ student.gradeName || '未知年级' }}
                                        </span>
                                        <span class="meta-divider">|</span>
                                        <span class="meta-item">
                                            <i class="el-icon-school"></i>
                                            {{ student.className || '未知班级' }}
                                        </span>
                                    </div>
                                </div>
                                <i class="el-icon-arrow-right card-arrow"></i>
                            </div>
                            <el-empty v-if="studentList.length === 0" description="暂无学生数据" :image-size="80"/>
                        </el-scrollbar>
                    </div>
                </el-col>

                <!-- 右侧：训练管理区域 -->
                <el-col :span="18">
                    <div v-if="!selectedStudent" class="empty-state">
                        <el-empty description="请从左侧选择一个学生"></el-empty>
                    </div>
                    <div v-else class="paper-management">
                        <!-- 学生信息卡片 -->
                        <div class="student-info-bar">
                            <div class="student-info-avatar" :style="{ background: getAvatarColor(selectedStudent.id) }">
                                {{ getAvatarText(selectedStudent.nickname || selectedStudent.username || selectedStudent.userName) }}
                            </div>
                            <div class="student-info-content">
                                <div class="info-name">{{ selectedStudent && (selectedStudent.nickname || selectedStudent.userName) }}</div>
                                <div class="info-row">
                                    <span class="info-tag"><i class="el-icon-document"></i>{{ selectedStudent && selectedStudent.studentNo || '未设置' }}</span>
                                    <span class="info-tag"><i class="el-icon-collection-tag"></i>{{ selectedStudent && selectedStudent.gradeName || '未知年级' }}</span>
                                    <span class="info-tag"><i class="el-icon-school"></i>{{ selectedStudent && selectedStudent.className || '未知班级' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 操作按钮 -->
                        <div class="action-bar">
                            <el-button type="primary" size="small" icon="el-icon-plus" @click="showGenerateDialog">生成训练</el-button>
                            <el-button size="small" icon="el-icon-refresh" @click="loadRecordList">刷新</el-button>
                        </div>

                        <!-- 训练记录筛选 -->
                        <div class="paper-filter-bar">
                            <el-date-picker
                                v-model="recordSearchDate"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                size="small"
                                value-format="yyyy-MM-dd"
                                style="width: 246px;">
                            </el-date-picker>
                            <el-select v-model="recordSearchVolume" placeholder="分册筛选" size="small" clearable style="width: 110px;" @change="handleRecordVolumeChange">
                                <el-option v-for="item in recordVolumeOptions" :key="item.value" :label="item.label" :value="item.value"/>
                            </el-select>
                            <el-select v-model="recordSearchUnit" placeholder="单元筛选" size="small" clearable style="width: 130px;" :disabled="!recordSearchVolume">
                                <el-option v-for="u in recordUnitList" :key="u.id" :label="u.unitName" :value="u.unitName"/>
                            </el-select>
                            <el-select v-model="recordSearchLevel" placeholder="级别筛选" size="small" clearable style="width: 110px;">
                                <el-option label="低阶" value="low"/>
                                <el-option label="中阶" value="medium"/>
                                <el-option label="高阶" value="high"/>
                            </el-select>
                            <el-select v-model="recordSearchStatus" placeholder="状态筛选" size="small" clearable style="width: 110px;">
                                <el-option v-for="s in statusList" :key="s.code" :label="s.desc" :value="s.code"/>
                            </el-select>
                            <el-button type="primary" size="small" icon="el-icon-search" @click="searchRecords">查询</el-button>
                            <el-button size="small" icon="el-icon-refresh-left" @click="resetRecordFilter">重置</el-button>
                        </div>

                        <!-- 训练记录列表 -->
                        <div class="paper-list-container">
                            <div class="paper-list-header">
                                <h3>训练记录</h3>
                                <span class="total-badge">共 <b>{{ recordTotal }}</b> 条</span>
                            </div>
                            <el-table
                                :data="recordList"
                                border
                                stripe
                                v-loading="tableLoading"
                                element-loading-text="加载中..."
                                style="width: 100%">
                                <el-table-column type="index" label="序号" width="60" align="center"/>
                                <el-table-column prop="snapshotVolume" label="分册" width="70" align="center"/>
                                <el-table-column prop="snapshotUnitName" label="单元" width="140" align="center" show-overflow-tooltip/>
                                <el-table-column prop="snapshotTitle" label="题目" min-width="160" show-overflow-tooltip/>
                                <el-table-column label="级别" width="80" align="center">
                                    <template slot-scope="s">
                                        <el-tag size="small" effect="plain"
                                            :type="s.row.essayLevel === 'high' ? 'danger' : s.row.essayLevel === 'medium' ? 'warning' : 'success'">
                                            {{ levelNameMap[s.row.essayLevel] || s.row.essayLevel }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态" width="90" align="center">
                                    <template slot-scope="s">
                                        <el-tag :type="statusType(s.row.status)" effect="plain" size="small">
                                            {{ statusText(s.row.status) }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="createTime" label="生成时间" width="160" align="center"/>
                                <el-table-column align="center" label="操作" width="240" fixed="right">
                                    <template slot-scope="s">
                                        <div class="action-btns">
                                            <el-dropdown trigger="click" @command="(cmd) => handleCommand(cmd, s.row)">
                                                <el-button size="mini">
                                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="preview" icon="el-icon-view">预览</el-dropdown-item>
                                                    <el-dropdown-item command="upload" icon="el-icon-upload2"
                                                        :disabled="s.row.status !== 1">上传图片</el-dropdown-item>
                                                    <el-dropdown-item command="viewImages" icon="el-icon-picture"
                                                        :disabled="s.row.status < 2">答题图片</el-dropdown-item>
                                                    <el-dropdown-item command="confirmGrading" icon="el-icon-check"
                                                        :disabled="s.row.status !== 2">确认批改</el-dropdown-item>
                                                    <el-dropdown-item command="rollback" icon="el-icon-refresh-left"
                                                        :disabled="s.row.status !== 3">回退</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                            <el-button size="mini" icon="el-icon-download" @click="handleCommand('download', s.row)">下载</el-button>
                                            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleCommand('delete', s.row)">删除</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="pagination-wrapper" v-if="recordTotal > 0">
                                <el-pagination
                                    background
                                    layout="total, sizes, prev, pager, next, jumper"
                                    @current-change="handlePageChange"
                                    @size-change="handleSizeChange"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :current-page="recordPage"
                                    :page-size="recordPageSize"
                                    :total="recordTotal">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-card>

        <!-- 生成训练弹窗 -->
        <el-dialog title="生成训练" :visible.sync="generateDialogVisible" width="550px" :close-on-click-modal="false" class="generate-dialog">
            <el-alert title="基于范文挖空+搭配+翻译，为学生生成微语境训练" type="info" :closable="false" show-icon style="margin-bottom:20px"/>
            <div class="generate-info">
                <div class="info-grid">
                    <div class="info-item"><span class="label">学生</span><span class="val">{{ selectedStudent && selectedStudent.userName }}</span></div>
                    <div class="info-item"><span class="label">年级</span><span class="val">{{ selectedStudent && selectedStudent.gradeName || '未知' }}</span></div>
                    <div class="info-item"><span class="label">班级</span><span class="val">{{ selectedStudent && selectedStudent.className || '未知' }}</span></div>
                </div>
            </div>
            <el-form :model="generateForm" label-width="100px" style="margin-top:20px">
                    <el-form-item label="分册">
                        <el-select v-model="generateForm.volume" placeholder="全部" clearable style="width:100%" @change="handleVolumeChange">
                            <el-option v-for="item in generateVolumeOptions" :key="item.value" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                <el-form-item label="单元">
                    <el-select v-model="generateForm.unitId" placeholder="全部" clearable style="width:100%" :disabled="!generateForm.volume" @change="loadQuestionsForGrade">
                        <el-option v-for="u in unitList" :key="u.id" :label="u.unitName" :value="u.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择题目" prop="questionId">
                    <el-select v-model="generateForm.questionId" placeholder="请选择题目" filterable style="width:100%">
                        <el-option v-for="q in questionList" :key="q.id" :label="q.title" :value="q.id"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="训练级别">
                    <el-radio-group v-model="generateForm.level">
                        <el-radio-button label="low">低阶 (2空/句)</el-radio-button>
                        <el-radio-button label="medium">中阶 (4空/句)</el-radio-button>
                        <el-radio-button label="high">高阶 (6空/句)</el-radio-button>
                    </el-radio-group>
                    <div style="font-size:12px;color:#909399;margin-top:6px">级别越高，每句话挖空越多，挑战越大</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="generateDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmGenerate" :loading="generating">确认生成</el-button>
            </div>
        </el-dialog>

        <!-- 训练预览弹窗 -->
        <el-dialog :close-on-click-modal="false" title="训练预览" :visible.sync="previewVisible" width="80%" top="5vh" class="preview-dialog">
            <div v-if="previewData" style="max-height:70vh;overflow-y:auto;padding:0 20px">
                <div style="text-align:center;margin-bottom:16px">
                    <h2>{{ previewData.title }}</h2>
                    <p style="color:#999;font-size:13px">级别：{{ previewData.levelName }}</p>
                </div>
                <el-tabs v-model="activeModule">
                    <el-tab-pane label="范文挖空" name="gapFill">
                        <el-tabs v-model="activeGapFillTab" type="border-card">
                            <el-tab-pane label="初级" name="low">
                                <template v-if="gapFillList('low').length > 0">
                                    <div v-for="item in gapFillList('low')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="success" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="中级" name="medium">
                                <template v-if="gapFillList('medium').length > 0">
                                    <div v-for="item in gapFillList('medium')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="warning" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                            <el-tab-pane label="高级" name="high">
                                <template v-if="gapFillList('high').length > 0">
                                    <div v-for="item in gapFillList('high')" :key="item.sentenceNo" style="margin-bottom:14px">
                                        <div style="display:flex;align-items:baseline;gap:8px">
                                            <span style="color:#909399;font-size:12px;min-width:30px">{{ item.sentenceNo }}.</span>
                                            <span style="white-space:pre-wrap;line-height:1.8">{{ item.gappedSentence }}</span>
                                        </div>
                                        <div style="margin-left:38px;margin-top:4px">
                                            <el-tag v-for="(ans,i) in item.answers" :key="i" size="small" type="danger" style="margin-right:6px;margin-bottom:4px">{{ ans }}</el-tag>
                                        </div>
                                    </div>
                                </template>
                                <el-empty v-else description="暂无数据" :image-size="50"/>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="固定搭配" name="collocations">
                        <el-table :data="previewData.collocationExercises" border size="small" v-if="previewData.collocationExercises && previewData.collocationExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="200"/>
                            <el-table-column prop="chinese" label="中文" min-width="200"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好词" name="words">
                        <el-table :data="previewData.goodWordExercises" border size="small" v-if="previewData.goodWordExercises && previewData.goodWordExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="160"/>
                            <el-table-column prop="chinese" label="中文" min-width="160"/>
                            <el-table-column prop="partOfSpeech" label="词性" width="80"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="好句" name="sentences">
                        <el-table :data="previewData.goodSentenceExercises" border size="small" v-if="previewData.goodSentenceExercises && previewData.goodSentenceExercises.length > 0">
                            <el-table-column type="index" label="#" width="40"/>
                            <el-table-column prop="english" label="英文" min-width="300"/>
                            <el-table-column prop="chinese" label="中文" min-width="300"/>
                        </el-table>
                        <el-empty v-else description="暂无数据" :image-size="50"/>
                    </el-tab-pane>
                    <el-tab-pane label="逐句翻译" name="translation">
                        <el-table :data="previewData.translationExercises" border size="small">
                            <el-table-column type="index" label="序号" width="60"/>
                            <el-table-column prop="chinese" label="汉语" min-width="250"/>
                            <el-table-column prop="englishReference" label="参考英语" min-width="250"/>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="汉语草稿" name="chineseDraft">
                        <h4 style="margin-bottom:8px">参考范文</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f5f7fa;padding:15px;border-radius:4px">{{ previewData.modelEssay }}</div>
                        <el-divider/>
                        <h4 style="margin-bottom:8px">全文翻译</h4>
                        <div style="white-space:pre-wrap;line-height:1.8;background:#f0f9eb;padding:15px;border-radius:4px">{{ previewData.fullTranslation }}</div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div slot="footer" v-if="previewData">
                <el-button type="primary" icon="el-icon-download" @click="handleDownloadFromPreview(previewData.instanceId)">下载Word</el-button>
            </div>
        </el-dialog>

        <!-- 上传答题图片弹窗 -->
        <el-dialog title="上传答题图片" :visible.sync="uploadDialogVisible" width="500px" :close-on-click-modal="false" @close="handleUploadClose">
            <el-alert title="上传学生的作文答题图片，支持jpg/png格式" type="info" :closable="false" show-icon style="margin-bottom:16px"/>
            <el-upload
                ref="essayUploader"
                :auto-upload="false"
                list-type="picture-card"
                accept="image/jpeg,image/png,image/jpg"
                multiple>
                <i class="el-icon-plus"></i>
            </el-upload>
            <div slot="footer">
                <el-button @click="uploadDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="uploading" @click="confirmUpload">保存并开始批改</el-button>
            </div>
        </el-dialog>

        <!-- 查看答题图片弹窗 -->
        <el-dialog title="答题图片" :visible.sync="viewImagesVisible" width="600px" :close-on-click-modal="false">
            <div v-loading="viewImagesLoading">
                <el-alert title="已保存的答题图片，仅供查看" type="info" :closable="false" show-icon style="margin-bottom:16px"/>
                <div v-if="viewImageList.length > 0" class="saved-images-grid">
                    <div v-for="(img, idx) in viewImageList" :key="idx" class="saved-image-item">
                        <el-image :src="img.url" fit="cover" :preview-src-list="viewImageUrls" style="width:100%;height:100%"></el-image>
                    </div>
                </div>
                <el-empty v-else description="暂无图片" :image-size="60"/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { generateEssay, previewEssay, downloadEssay, reqInstancePage, reqInstanceDelete, reqQuestionPage, reqStartGrading, reqCompleteGrading, reqRollbackGrading } from '@/api/education/essay'
import { getStudentList } from '@/api/education/assessment'
import { uploadFile, batchSaveAttachments, getAttachments } from '@/api/system/file'
import { reqGradeList } from '@/api/education/grade'
import { reqClassList } from '@/api/education/class'
import { reqUnitsByGradeAndVolume, reqVolumeOptions } from '@/api/education/unit'
import global from "@/api/global";

export default {
    name: 'EssayGenerate',
    data() {
        return {
            filterForm: { gradeId: null, classId: null, studentNo: '', userName: '', phone: '' },
            gradeList: [],
            classList: [],
            studentList: [],
            selectedStudent: null,
            recordList: [],
            recordTotal: 0,
            recordPageSize: 10,
            recordPage: 1,
            recordSearchDate: null,
            recordSearchVolume: null,
            recordSearchUnit: null,
            recordUnitList: [],
            recordVolumeOptions: [],
            generateVolumeOptions: [],
            recordSearchLevel: null,
            recordSearchStatus: null,
            statusList: [
                { code: 1, desc: '已生成' },
                { code: 2, desc: '批改中' },
                { code: 3, desc: '已批改' }
            ],
            tableLoading: false,
            questionList: [],
            unitList: [],
            levelNameMap: { low: '低阶', medium: '中阶', high: '高阶' },
            generateDialogVisible: false,
            generateForm: { questionId: null, level: 'medium', volume: null, unitId: null },
            generating: false,
            previewVisible: false,
            previewData: null,
            activeModule: 'gapFill',
            activeGapFillTab: 'low',
            uploadDialogVisible: false,
            uploadInstanceId: null,
            uploading: false,
            viewImagesVisible: false,
            viewImageList: [],
            viewImageUrls: [],
            viewImagesLoading: false
        }
    },
    created() {
        this.loadGradeList()
        this.loadStudents()
    },
    methods: {
        async loadGradeList() {
            try { const r = await reqGradeList(); this.gradeList = r || [] } catch (e) { this.gradeList = [] }
        },
        gapFillList(level) {
            return this.previewData?.gapFillLevels?.[level] || []
        },
        async handleGradeChange(gradeId) {
            this.filterForm.classId = null
            if (!gradeId) { this.classList = []; return }
            try {
                const res = await reqClassList({ gradeId })
                this.classList = res.data || res || []
            } catch (e) { this.classList = [] }
        },
        async loadStudents() {
            try {
                const res = await getStudentList({
                    gradeId: this.filterForm.gradeId,
                    classId: this.filterForm.classId,
                    studentNo: this.filterForm.studentNo,
                    username: this.filterForm.userName,
                    phone: this.filterForm.phone,
                    roleMark: 'STUDENT',
                    currentPage: 1,
                    pageSize: 500
                })
                let students = []
                if (res.data && res.data.records) students = res.data.records
                else if (res.records) students = res.records
                else if (Array.isArray(res)) students = res
                this.studentList = students.map(s => ({
                    ...s,
                    userName: s.nickname || s.userName || '',
                    studentNo: s.studentNo || '未设置',
                    gradeName: s.gradeName || '未知年级',
                    className: s.className || '未知班级'
                }))
            } catch (e) {
                console.error('加载学生列表失败:', e)
                this.studentList = []
            }
        },
        resetFilter() {
            this.filterForm = { gradeId: null, classId: null, studentNo: '', userName: '', phone: '' }
            this.classList = []
            this.loadStudents()
        },
        getAvatarText(name) { return name ? name.charAt(0).toUpperCase() : '?' },
        getAvatarColor(id) {
            const colors = ['#409eff', '#67c23a', '#e6a23c', '#f56c6c', '#9b59b6', '#1abc9c', '#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#8e44ad', '#16a085']
            return colors[(id || 0) % colors.length]
        },
        handleStudentSelect(student) {
            this.selectedStudent = student
            this.recordPage = 1
            this.loadRecordList()
            // 加载该学生年级对应的分册选项（用于记录筛选）
            if (student.gradeId) {
                this.loadRecordVolumeOptions(student.gradeId)
            }
        },
        async loadRecordVolumeOptions(gradeId) {
            try {
                const res = await reqVolumeOptions(gradeId)
                const list = (res && Array.isArray(res)) ? res : []
                this.recordVolumeOptions = list.map(v => ({ label: v, value: v }))
            } catch (e) { this.recordVolumeOptions = [] }
        },
        handleRecordVolumeChange() {
            this.recordSearchUnit = null
            this.loadRecordUnitList()
        },
        async loadRecordUnitList() {
            const gradeId = this.selectedStudent?.gradeId
            const volume = this.recordSearchVolume
            if (!gradeId || !volume) { this.recordUnitList = []; return }
            try {
                const r = await reqUnitsByGradeAndVolume(gradeId, volume)
                this.recordUnitList = r || []
            } catch (e) { this.recordUnitList = [] }
        },
        async loadUnitList() {
            const gradeId = this.selectedStudent?.gradeId
            const volume = this.generateForm.volume
            if (!gradeId || !volume) { this.unitList = []; return }
            try {
                const r = await reqUnitsByGradeAndVolume(gradeId, volume)
                this.unitList = r || []
            } catch (e) { this.unitList = [] }
        },
        handleVolumeChange() {
            this.generateForm.questionId = null
            this.generateForm.unitId = null
            this.loadUnitList()
        },
        async loadQuestionsForGrade() {
            if (!this.selectedStudent) return
            const params = { currentPage: 1, pageSize: 999, status: 1 }
            if (this.selectedStudent.gradeId) params.gradeId = this.selectedStudent.gradeId
            if (this.generateForm.volume) params.volume = this.generateForm.volume
            if (this.generateForm.unitId) params.unitId = this.generateForm.unitId
            try {
                const r = await reqQuestionPage(params)
                this.questionList = r.records || []
            } catch (e) { this.questionList = [] }
        },
        async loadRecordList() {
            if (!this.selectedStudent) return
            this.tableLoading = true
            try {
                const params = { currentPage: this.recordPage, pageSize: this.recordPageSize, studentUserId: this.selectedStudent.id }
                if (this.recordSearchStatus != null && this.recordSearchStatus !== '') params.status = this.recordSearchStatus
                if (this.recordSearchLevel) params.essayLevel = this.recordSearchLevel
                if (this.recordSearchVolume) params.volume = this.recordSearchVolume
                if (this.recordSearchUnit) params.unitName = this.recordSearchUnit
                if (this.recordSearchDate && this.recordSearchDate.length === 2) {
                    params.startTime = this.recordSearchDate[0]
                    params.endTime = this.recordSearchDate[1]
                }
                const r = await reqInstancePage(params)
                this.recordList = r.records || []
                this.recordTotal = r.total || 0
            } catch (e) {
                this.recordList = []
                this.recordTotal = 0
            } finally {
                this.tableLoading = false
            }
        },
        searchRecords() {
            this.recordPage = 1
            this.loadRecordList()
        },
        resetRecordFilter() {
            this.recordSearchDate = null
            this.recordSearchVolume = null
            this.recordSearchUnit = null
            this.recordUnitList = []
            this.recordSearchLevel = null
            this.recordSearchStatus = null
            this.recordPage = 1
            this.loadRecordList()
        },
        handlePageChange(page) { this.recordPage = page; this.loadRecordList() },
        handleSizeChange(size) { this.recordPageSize = size; this.recordPage = 1; this.loadRecordList() },
        showGenerateDialog() {
            this.generateForm = { questionId: null, level: 'medium', volume: null, unitId: null }
            this.questionList = []
            this.unitList = []
            // 加载该学生年级对应的分册选项
            if (this.selectedStudent?.gradeId) {
                this.loadGenerateVolumeOptions(this.selectedStudent.gradeId)
            }
            this.generateDialogVisible = true
            this.$nextTick(() => this.loadQuestionsForGrade())
        },
        async loadGenerateVolumeOptions(gradeId) {
            try {
                const res = await reqVolumeOptions(gradeId)
                const list = (res && Array.isArray(res)) ? res : []
                this.generateVolumeOptions = list.map(v => ({ label: v, value: v }))
            } catch (e) { this.generateVolumeOptions = [] }
        },
        async confirmGenerate() {
            if (!this.generateForm.questionId) { this.$message.warning('请选择题目'); return }
            this.generating = true
            try {
                await generateEssay({
                    studentId: this.selectedStudent.id,
                    questionId: this.generateForm.questionId,
                    level: this.generateForm.level
                })
                this.generateDialogVisible = false
                await this.loadRecordList()
                this.$message.success('生成成功')
            } catch (e) {
                this.$message.error('生成失败：' + (e.message || '未知错误'))
            } finally {
                this.generating = false
            }
        },
        handleCommand(command, row) {
            switch (command) {
                case 'preview': this.handlePreview(row); break
                case 'upload': this.handleUploadImage(row); break
                case 'viewImages': this.handleViewImages(row); break
                case 'confirmGrading': this.handleConfirmGrading(row); break
                case 'rollback': this.handleRollback(row); break
                case 'download': this.handleDownload(row); break
                case 'delete': this.handleDelete(row.id); break
            }
        },
        async handlePreview(row) {
            try {
                const r = await previewEssay(row.id)
                this.previewData = r
                this.activeModule = 'gapFill'
                this.activeGapFillTab = r.level || 'low'
                this.previewVisible = true
            } catch (e) { this.$message.error('预览加载失败') }
        },
        async handleDownload(row) {
            try {
                const r = await downloadEssay(row.id)
                if (r) window.open(global.preview_path_url + r, '_blank')
                else this.$message.warning('下载链接为空')
            } catch (e) { this.$message.error('下载失败') }
        },
        async handleDownloadFromPreview(id) {
            try {
                const r = await downloadEssay(id)
                if (r) window.open(r, '_blank')
                else this.$message.warning('下载链接为空')
            } catch (e) { this.$message.error('下载失败') }
        },
        handleDelete(id) {
            this.$confirm('确认删除？').then(() => {
                reqInstanceDelete(id).then(() => { this.$message.success('已删除'); this.loadRecordList() })
            })
        },
        handleUploadImage(row) {
            this.uploadInstanceId = row.id
            this.uploadDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.essayUploader) this.$refs.essayUploader.clearFiles()
            })
        },
        handleUploadClose() {
            this.uploadInstanceId = null
        },
        async handleViewImages(row) {
            this.viewImagesLoading = true
            this.viewImagesVisible = true
            try {
                const res = await getAttachments(row.id, 3)
                const list = res.data || res || []
                this.viewImageList = list.map(item => ({ url: item.url, name: item.name }))
                this.viewImageUrls = this.viewImageList.map(item => item.url)
            } catch (e) {
                this.viewImageList = []
                this.viewImageUrls = []
                this.$message.error('加载图片失败')
            } finally {
                this.viewImagesLoading = false
            }
        },
        async confirmUpload() {
            const files = this.$refs.essayUploader ? this.$refs.essayUploader.uploadFiles : []
            if (!files || files.length === 0) {
                this.$message.warning('请至少选择一张图片')
                return
            }
            this.uploading = true
            try {
                const attachments = []
                for (const f of files) {
                    const res = await uploadFile(f.raw)
                    const url = res.data || res.url || res
                    attachments.push({ url, name: f.name })
                }
                await batchSaveAttachments(this.uploadInstanceId, 3, attachments)
                await reqStartGrading(this.uploadInstanceId)
                this.$message.success('图片上传成功，状态已更新为批改中')
                this.uploadDialogVisible = false
                this.loadRecordList()
            } catch (error) {
                this.$message.error('操作失败：' + (error.message || '未知错误'))
            } finally {
                this.uploading = false
            }
        },
        async handleConfirmGrading(row) {
            this.$confirm('确认批改结果？').then(async () => {
                try {
                    await reqCompleteGrading(row.id)
                    this.$message.success('已确认为已批改')
                    this.loadRecordList()
                } catch (e) {
                    this.$message.error('确认失败：' + (e.message || '未知错误'))
                }
            })
        },
        async handleRollback(row) {
            this.$confirm('确定要回退到"已生成"状态吗？回退后可重新上传图片。', '提示', { type: 'warning' }).then(async () => {
                try {
                    await reqRollbackGrading(row.id)
                    this.$message.success('已回退到已生成状态')
                    this.loadRecordList()
                } catch (e) {
                    this.$message.error('回退失败：' + (e.message || '未知错误'))
                }
            })
        },
        statusType(status) {
            return { 1: 'success', 2: 'warning', 3: '' }[status] || 'info'
        },
        statusText(status) {
            return { 1: '已生成', 2: '批改中', 3: '已批改' }[status] || '未知'
        }
    }
}
</script>

<style scoped lang="scss">
.generate-page {
    .filter-card,
    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                margin-right: 6px;
                color: #409EFF;
            }

            .el-divider {
                margin: 0 10px;
                background-color: #dcdfe6;
            }

            .header-sub {
                font-weight: 400;
                font-size: 13px;
                color: #909399;
            }
        }
    }

    .filter-form {
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
    }

    .student-list-container {
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 0;
        background: #fff;
        height: calc(100vh - 220px);
        display: flex;
        flex-direction: column;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
        overflow: hidden;

        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        ::v-deep .el-scrollbar__bar.is-horizontal {
            display: none;
        }

        .list-header {
            padding: 14px 18px;
            border-bottom: 1px solid #e4e7ed;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fafbfc;

            h3 {
                margin: 0;
                font-size: 15px;
                color: #303133;
                font-weight: 600;
            }

            .count-badge {
                background: #e8edf3;
                color: #606266;
                padding: 1px 10px;
                border-radius: 10px;
                font-size: 12px;
                font-weight: 500;
            }
        }
    }

    .student-card {
        display: flex;
        align-items: center;
        padding: 12px 18px;
        border-bottom: 1px solid #f2f3f5;
        cursor: pointer;
        transition: background 0.2s;
        background: #fff;
        position: relative;

        &:hover {
            background: #f5f7fa;

            .card-arrow {
                opacity: 1;
                transform: translateX(0);
            }
        }

        &.active {
            background: #ecf5ff;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 3px;
                background: #409eff;
                border-radius: 0 2px 2px 0;
            }

            .card-arrow {
                opacity: 1;
                color: #409eff;
            }
        }

        .student-avatar {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            font-weight: 600;
            margin-right: 12px;
            flex-shrink: 0;
            letter-spacing: 1px;
        }

        .student-info {
            flex: 1;
            min-width: 0;

            .student-name {
                font-size: 14px;
                font-weight: 600;
                color: #303133;
                margin-bottom: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .student-meta {
                display: flex;
                align-items: center;
                gap: 4px;
                font-size: 12px;
                color: #909399;

                .meta-item {
                    display: flex;
                    align-items: center;
                    gap: 2px;

                    i {
                        font-size: 12px;
                    }
                }

                .meta-divider {
                    color: #dcdfe6;
                    margin: 0 4px;
                }
            }
        }

        .card-arrow {
            font-size: 14px;
            color: #c0c4cc;
            opacity: 0;
            transform: translateX(-4px);
            transition: all 0.2s;
            margin-left: 8px;
        }
    }

    .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
    }

    .paper-management {
        .student-info-bar {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 14px 20px;
            background: #ecf5ff;
            border-radius: 8px;
            border: 1px solid #d9ecff;

            .student-info-avatar {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                flex-shrink: 0;
                letter-spacing: 1px;
            }

            .student-info-content {
                flex: 1;
                min-width: 0;

                .info-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: #303133;
                    margin-bottom: 6px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .info-row {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 8px;

                    .info-tag {
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;
                        font-size: 12px;
                        color: #606266;
                        background: #fff;
                        padding: 2px 10px;
                        border-radius: 12px;
                        border: 1px solid #e4e7ed;

                        i {
                            font-size: 12px;
                            color: #909399;
                        }
                    }
                }
            }
        }

        .action-bar {
            padding: 12px 0;
            margin-top: 12px;
            border-bottom: 1px solid #ebeef5;
        }

        .paper-filter-bar {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 12px 0;
            border-bottom: 1px solid #ebeef5;
        }

        .paper-list-container {
            margin-top: 16px;

            .paper-list-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 12px;

                h3 {
                    margin: 0;
                    font-size: 15px;
                    color: #303133;
                    font-weight: 600;
                }

                .total-badge {
                    font-size: 13px;
                    color: #606266;

                    b {
                        color: #409EFF;
                    }
                }
            }
        }
    }

    .generate-info {
        padding: 15px;
        background: #f5f7fa;
        border-radius: 4px;

        .info-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 12px;

            .info-item {
                display: flex;
                flex-direction: column;
                gap: 2px;

                .label {
                    font-size: 12px;
                    color: #909399;
                }

                .val {
                    font-size: 14px;
                    color: #303133;
                    font-weight: 500;
                }
            }
        }
    }

    .saved-images-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    }

    .saved-image-item {
        width: 120px;
        height: 120px;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #e4e7ed;
    }

    .action-btns {
        display: flex;
        align-items: center;
        gap: 6px;
        justify-content: center;
    }

    .danger-dropdown-item {
        color: #f56c6c !important;

        &:hover {
            background: #fef0f0 !important;
            color: #f56c6c !important;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 12px;
    }

    // 表格统一样式
    ::v-deep .el-table {
        th.el-table__cell {
            background-color: #fafafa;
            color: #606266;
            font-weight: 600;
        }
    }

    // el-card body padding
    ::v-deep .table-card > .el-card__body {
        padding: 16px;
    }
}

@media (max-width: 768px) {
    .generate-page {
        .filter-card,
        .table-card {
            margin: 8px 6px;
        }
    }
}
</style>
